import { Button } from '~/components/buttons';

type Props = {
  action: {
    responseId: number;
    kind: 'reply' | 'accept' | 'accept_listing' | 'withdraw' | 'reject';
  } | null;
  busy: boolean;
  canAcknowledge: boolean;
  onReview: () => void;
  onAcknowledge: () => void;
  onDiscard: () => void;
  discardsDraft?: boolean;
};

export const OpportunityRecoveryNotice = ({
  action,
  busy,
  canAcknowledge,
  onReview,
  onAcknowledge,
  onDiscard,
  discardsDraft = false,
}: Props) => (
  <div className="mb-4" data-cy="opportunity-recovery">
    <p role="status" aria-live="polite" className="body-text">
      {action
        ? `An earlier ${action.kind === 'reply' ? 'message' : 'status change'} for response #${action.responseId} is unconfirmed. A refresh cannot prove that your ${action.kind === 'reply' ? 'message was sent' : 'status change completed'}. Review the original conversation before deciding whether to send or act again; repeating an action may duplicate it.`
        : ''}
    </p>
    {action && (
      <>
        <div className="mt-2 flex flex-wrap gap-2">
          <Button
            type="button"
            size="sm"
            label="Review original conversation"
            disabled={busy}
            onClick={onReview}
          />
          <Button
            type="button"
            size="sm"
            label="I reviewed the conversation"
            disabled={busy || !canAcknowledge}
            onClick={onAcknowledge}
          />
          <Button
            type="button"
            size="sm"
            label="Discard local tracking"
            disabled={busy}
            onClick={onDiscard}
          />
        </div>
        <p className="body-text mt-2">
          {discardsDraft
            ? 'Review acknowledgement preserves your draft. Discard local tracking also discards the retained draft. Neither action resends, cancels, or undoes server work.'
            : 'Review acknowledgement and discard only clear local tracking. They do not resend, cancel, or undo server work.'}
        </p>
      </>
    )}
  </div>
);
